import React from 'react';
import { Layer } from 'react-mapbox-gl';

const layers = [
  {
    id: 'background',
    type: 'background',
    paint: {
      'background-color': '#fcfcfc',
    },
  },
  {
    id: 'buster',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['match', ['get', 'type'], ['border', 'buster'], true, false],
    ],
    paint: {
      'fill-color': '#fff',
    },
  },
  {
    id: 'section-fill',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['==', ['get', 'type'], 'section'],
    ],
    paint: {
      'fill-color': 'rgb(224,224,224)',
      'fill-antialias': true,
      'fill-outline-color': 'rgb(158,158,158)',
      'fill-opacity': 1,
    },
  },
  {
    id: 'dirt-dark',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['==', ['get', 'type'], 'dirt-dark'],
    ],
    paint: {
      'fill-color': 'rgb(157, 103, 79)',
    },
  },
  {
    id: 'dark-green',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['==', ['get', 'type'], 'dark-green'],
    ],
    paint: {
      'fill-color': 'rgb(58, 99, 29)',
    },
  },
  {
    id: 'light-dirt',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['==', ['get', 'type'], 'dirt-light'],
    ],
    paint: {
      'fill-color': 'rgb(202, 139, 88)',
    },
  },
  {
    id: 'infield-grass',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['==', ['get', 'type'], 'dark-green2'],
    ],
    paint: {
      'fill-color': 'rgb(58, 99, 29)',
    },
  },
  {
    id: 'light-green',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['==', ['get', 'type'], 'light-green'],
    ],
    paint: {
      'fill-color': 'hsla(108, 26%, 40%, 0.7)',
    },
  },
  {
    id: 'pitchers-mound',
    type: 'fill',
    filter: ['==', ['get', 'type'], 'mound'],
    paint: {
      'fill-color': 'rgb(202, 139, 88)',
    },
  },
  {
    id: 'dark-green-alt',
    type: 'fill',
    filter: ['==', ['get', 'type'], 'dark-green-alt'],
    paint: {
      'fill-color': 'rgb(58, 99, 29)',
    },
  },
  {
    id: 'hex-fill',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['==', ['get', 'type'], 'hex'],
    ],
    paint: {
      'fill-color': ['coalesce', ['get', 'hex'], '#fff'],
    },
  },
  {
    id: 'rim',
    type: 'fill',
    filter: ['all',
      ['match', ['geometry-type'], ['LineString', 'Point', 'Polygon'], true, false],
      ['==', ['get', 'type'], 'rim'],
    ],
    paint: {
      'fill-color': '#fa8320',
    },
  },
  {
    id: 'white-fill',
    type: 'fill',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['==', ['get', 'type'], 'white'],
    ],
    paint: {
      'fill-color': '#fff',
    },
  },
  // id: 'section-listing-fill' (sections.js)
  // id: 'row-fill' (rows.js)
  // id: 'row-listing-fill' (rows.js)
  // id: 'row-selected-listing-fill' (rows.js)
  {
    id: 'stage',
    type: 'fill',
    filter: ['==', ['get', 'type'], 'stage'],
    paint: {
      'fill-color': 'rgb(77, 77, 77)',
    },
  },
  {
    id: 'buster-stroke',
    type: 'line',
    filter: ['all',
      ['==', ['geometry-type'], 'Polygon'],
      ['match', ['get', 'type'], ['border', 'buster'], true, false],
    ],
    layout: {
      'line-join': 'round',
    },
    paint: {
      'line-color': '#b7b6b8',
      'line-width': [
        'interpolate', ['exponential', 1], ['zoom'],
        2, 2,
        8, 8,
      ],
    },
  },
  // id: 'row-stroke' (rows.js)
  // id: 'section-stroke' (sections.js)
  {
    id: 'paint',
    type: 'line',
    filter: ['==', ['get', 'type'], 'line'],
    paint: {
      'line-color': ['coalesce', ['get', 'hex'], '#fff'],
      'line-width': [
        'interpolate', ['exponential', 1.5], ['zoom'],
        2, 0,
        8, 3,
      ],
    },
  },
  {
    id: 'chalk',
    type: 'line',
    filter: ['all',
      ['match', ['geometry-type'], ['LineString', 'Point', 'Polygon'], true, false],
      ['==', ['get', 'type'], 'chalk'],
    ],
    paint: {
      'line-color': ['coalesce', ['get', 'hex'], '#fff'],
      'line-width': [
        'interpolate', ['exponential', 1.5], ['zoom'],
        4, 1,
        8, 6,
      ],
    },
  },
  {
    id: 'field-goal-post',
    type: 'circle',
    filter: ['all',
      ['==', ['geometry-type'], 'Point'],
      ['==', ['get', 'type'], 'field-goal-post'],
    ],
    paint: {
      'circle-color': '#fa8320',
      'circle-radius': [
        'interpolate', ['exponential', 1.8], ['zoom'],
        2, 2,
        8, 10,
      ],
    },
  },
  {
    id: 'field-goal',
    type: 'line',
    filter: ['all',
      ['==', ['geometry-type'], 'LineString'],
      ['==', ['get', 'type'], 'field-goal'],
    ],
    paint: {
      'line-color': '#ffcc00',
      'line-width': [
        'interpolate', ['exponential', 1.8], ['zoom'],
        2, 2,
        8, 16,
      ],
    },
  },
  // id: 'row-label' (labels.js)
  // id: 'section-label' (labels.js)
  // id: 'poi-label' (labels.js)
  // id: 'stage-label' (labels.js)
  // id: 'football-label' (labels.js)
  // id: 'football-team-names' (labels.js)
];

const BaseStyles = () => layers.map(style => (
  <Layer
    key={style.id}
    sourceId="venue"
    sourceLayer="data"
    {...style}
  />
));

BaseStyles.shouldComponentUpdate = () => false;

export default BaseStyles;



// WEBPACK FOOTER //
// ./src/styles/base.js